module.exports = __webpack_public_path__ + "static/media/Earth.7bc76e51.png";